import styled from 'styled-components/macro';
import { Button, Typography } from '@redis-ui/components';

export const UserFormInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 14rem;
  align-items: flex-start;
  justify-content: flex-start;
  width: 40rem;
`;

export const UserFormInfoTitle = styled(Typography.Heading)`
  color: ${({ theme }) =>
    theme.appComponents.login.components.userFormInfo.userFormInfoTitle.color};
  white-space: pre-wrap;
`;
export const UserFormInfoSubTitle = styled(Typography.Body)`
  color: ${({ theme }) =>
    theme.appComponents.login.components.userFormInfo.userFormInfoSubTitle.color};
  font-size: 1.8rem;
  margin-bottom: 3rem;
  margin-top: 0.8rem;
`;

export const UserFormInfoText = styled(Typography.Body)`
  color: ${({ theme }) => theme.appComponents.login.components.userFormInfo.userFormInfoText.color};
  margin-top: 1.6rem;
  white-space: pre-wrap;
`;
export const ButtonContainer = styled(Button)`
  align-self: flex-end;
  margin-top: 5rem;
`;
